import { Action, Dispatch } from "redux";
import { AxiosError, AxiosResponse } from "axios";
import { notification } from "antd";

import { AuthorizedApiService } from "../../../services/apiServices";
import { GET_ERROR_LOGS, IS_LOADING } from "./types";

const setLoading = (loading: boolean) => ({
  type: IS_LOADING,
  payload: loading,
});

export const getErrorLogs =
  (page = 1, limit = 25) =>
  async (dispatch: Dispatch<Action>) => {
    try {
      dispatch(setLoading(true));
      AuthorizedApiService.get("/error-logs", { params: { page, limit } })
        .then((res: AxiosResponse) => {
          const { status, data } = res;
          if (status !== 200) {
            notification.error({
              message: "Something went wrong",
            });
            return;
          }

          dispatch({
            type: GET_ERROR_LOGS,
            payload: data,
          });
        })
        .catch((err: AxiosError) => {
          notification.error({
            message: "Something went wrong",
          });
        })
        .finally(() => {
          dispatch(setLoading(false));
        });
    } catch (err) {
      dispatch(setLoading(false));
    }
  };
